<template>
    <custom-drawer
        v-loading="loading"
        size="85%"
        :wrapper_closable="false"
        :visible.sync="visible_in_line"
    >
        <template slot="title">
            <div class="items-center h-full flex pl-4 pr-8 justify-between">
                <p class="font-semibold">
                    {{ title_copy_campaign }}
                </p>
                <el-button
                    icon="el-icon-copy-document"
                    type="primary"
                    size="small"
                    :disabled="multiple_selection_adgroups.length === 0"
                    @click="handleCopy"
                >
                    {{ $t('button.confirm') }}
                </el-button>
            </div>
        </template>

        <section class="py-8 pl-[84px] pr-8">
            <div
                v-if="copy_item"
                id="input_campaign_name_wrapper"
                class="mb-4 flex space-x-4 component-box w-[680px]"
            >
                <div class="w-[60%]">
                    <p class="component-label">
                        {{ $t('page.campaign.campaign_name') }}
                    </p>
                    <el-input
                        id="input_campaign_name"
                        v-model="copy_item.campaign_name"
                        size="small"
                    ></el-input>
                </div>
                <!-- <div class="flex-1">
                    <p class="component-label">
                        {{ $t('input.placeholder.select_ads_account') }}
                    </p>
                    <el-select
                        v-model="selected_advertiser_id"
                        filterable
                        size="small"
                        :placeholder="
                            $t('input.placeholder.select_ads_account')
                        "
                        class="w-[240px] !ml-auto"
                    >
                        <el-option-group
                            :label="$t('common.advertiser_account')"
                        >
                            <el-option
                                v-for="ads in m__ads_accounts"
                                :key="ads.advertiser_id"
                                :label="ads.name"
                                :value="ads.advertiser_id"
                            >
                                <div class="flex items-center space-x-2 py-1">
                                    <div class="flex flex-col">
                                        <span
                                            class="leading-5 text-[0.8rem] font-semibold"
                                        >
                                            {{ ads.name }}
                                        </span>
                                        <span class="component-text-desc">
                                            #{{ ads.advertiser_id }}
                                        </span>
                                    </div>
                                </div>
                            </el-option>
                        </el-option-group>
                    </el-select>
                </div> -->
            </div>

            <div class="component-box">
                <div
                    v-if="m__page_info"
                    class="flex items-center space-x-4 mb-4"
                >
                    <p
                        v-if="m__page_info.total_number > 0"
                        class="font-semibold text-[0.85rem]"
                    >
                        {{
                            `${m__page_info.total_number} ${$t(
                                'common.xxx_has_plural_noun',
                                {
                                    xxx: $t(`common.adgroup`)
                                }
                            )}`
                        }}
                    </p>

                    <div class="!ml-auto"></div>

                    <el-select
                        v-model="m__page_info.page_size"
                        filterable
                        class="w-[120px]"
                        size="small"
                        @change="
                            m__handleChangePagesize(
                                m__getReportCampaignsByAccount
                            )
                        "
                    >
                        <el-option
                            v-for="i in m__list_pagesize"
                            :key="i.value"
                            :label="i.label"
                            :value="i.value"
                        >
                        </el-option>
                    </el-select>

                    <el-input-number
                        v-model="m__page_info.page"
                        class="w-[120px]"
                        size="small"
                        :min="1"
                        :max="m__page_info.total_page"
                        @change="m__getReportCampaignsByAccount"
                    ></el-input-number>

                    <el-button
                        icon="el-icon-refresh"
                        size="small"
                        @click="m__getReportCampaignsByAccount"
                    ></el-button>
                </div>

                <el-table
                    ref="multipleTable"
                    v-loading="m__loading"
                    class="campaign-table"
                    :data="m__data_for_pagination"
                    @selection-change="handleSelectionChange"
                    @sort-change="m__handleSortChange"
                >
                    <el-table-column type="selection" width="40" :fixed="true">
                    </el-table-column>

                    <el-table-column
                        min-width="300"
                        prop="adgroup.adgroup_name"
                        :label="$t('common.name')"
                        :fixed="true"
                    >
                        <template #default="scope">
                            <div class="group hover:text-brand-atosa--light">
                                <div
                                    class="group cursor-pointer"
                                    @click="handleEditAdGroup(scope.row)"
                                >
                                    <el-tooltip
                                        class="item"
                                        effect="dark"
                                        :content="
                                            scope.row.adgroup.adgroup_name
                                        "
                                        placement="top"
                                    >
                                        <p
                                            class="group-hover:underline truncate"
                                        >
                                            {{ scope.row.adgroup.adgroup_name }}
                                        </p>
                                    </el-tooltip>
                                </div>

                                <div
                                    class="invisible group-hover:visible flex items-center space-x-4"
                                >
                                    <div
                                        class="flex items-center space-x-1 cursor-pointer hover:underline"
                                        @click="handleEditAdGroup(scope.row)"
                                    >
                                        <font-awesome-icon
                                            icon="fa-regular fa-pen-to-square"
                                        ></font-awesome-icon>
                                        <p>
                                            {{ $t('common.edit') }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column
                        min-width="160"
                        :show-overflow-tooltip="true"
                        prop="adgroup.adgroup_id"
                        :label="
                            $t('common.xxx_id', {
                                xxx: $t(`common.adgroup`)
                            })
                        "
                    />

                    <el-table-column :label="$t('common.budget')" width="100px">
                        <template #default="scope">
                            <p class="font-semibold">
                                {{
                                    p__renderMoneyByCurrency(
                                        scope.row.adgroup.budget,
                                        scope.row.currency
                                    )
                                }}
                            </p>
                            <p class="component-text-desc">
                                {{
                                    p__formatBudgetMode(
                                        scope.row.adgroup.budget_mode
                                    )
                                }}
                            </p>
                        </template>
                    </el-table-column>

                    <el-table-column
                        width="120"
                        :show-overflow-tooltip="true"
                        prop="adgroup.bid_price"
                        label="BID"
                        align="right"
                    />

                    <el-table-column
                        :label="$t('common.ad_scheduling')"
                        width="160px"
                    >
                        <template #default="scope">
                            <p>
                                {{
                                    p__formatDate(
                                        scope.row.adgroup.schedule_start_time
                                    )
                                }}
                            </p>
                            <p>
                                {{
                                    p__formatDate(
                                        scope.row.adgroup.schedule_end_time
                                    )
                                }}
                            </p>
                        </template>
                    </el-table-column>

                    <el-table-column
                        v-for="(item, index) in m__selected_columns"
                        :key="index"
                        width="160"
                        :show-overflow-tooltip="true"
                        :prop="item"
                        :label="$t(`page.campaign.column_${item}`)"
                        sortable="custom"
                        align="right"
                    >
                        <template v-slot:header>
                            <el-tooltip
                                class="item"
                                :content="$t(`page.campaign.column_${item}`)"
                                effect="dark"
                                placement="top"
                            >
                                <p>
                                    {{ $t(`page.campaign.column_${item}`) }}
                                </p>
                            </el-tooltip>
                        </template>

                        <template #default="scope">
                            <p>
                                {{
                                    m__formatterColumn(
                                        scope.row[item],
                                        item,
                                        scope.row.currency
                                    )
                                }}
                            </p>
                            <p v-if="scope.row.compare" class="text-desc-text">
                                {{
                                    m__formatterColumn(
                                        scope.row.compare[item],
                                        item,
                                        scope.row.currency
                                    )
                                }}
                            </p>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </section>

        <EditAdgroupDrawer
            :item="active_adgroup_item"
            :objective_type="objective_type"
            :tiktok_account_id="tiktok_account_id"
            :min_budget_adgroup="min_budget_adgroup"
            :advertiser_id="advertiser_id"
            :currency="active_currency"
            :timezone="active_timezone"
            :handle_change_adgroup="handleChangeAdgroup"
            :visible.sync="is_edit_adgroup_drawer_displayed"
        ></EditAdgroupDrawer>
    </custom-drawer>
</template>

<script>
import campaignMixin from '../../_mixin'
import { createCampaign } from '@/services/atosa-tiktok-ads/campaign'
import { createAdGroup } from '@/services/atosa-tiktok-ads/adgroup'
import { getAds, createAd } from '@/services/atosa-tiktok-ads/ad'
import EditAdgroupDrawer from './edit-adgroup-drawer'
import selectedTiktokAccountMixin from '@/plugins/mixins/selected-tiktok-accounts'
import { removeEmptyParams } from '@/views/campaign/_utils'
import EditAdgroupFormMixin from '@/components/orgranisms/edit-adgroup-form/_mixin'
import moment from 'moment'
import { updateCampaignStatus } from '@/services/atosa-tiktok-ads/campaign'

export default {
    components: {
        EditAdgroupDrawer
    },

    mixins: [campaignMixin, selectedTiktokAccountMixin, EditAdgroupFormMixin],

    props: ['visible', 'item', 'tiktok_account_id'],

    data() {
        return {
            selected_advertiser_id: null,
            copy_item: null,
            active_adgroup_item: null,
            loading: false,
            multiple_selection_adgroups: [],
            active_currency: null,
            active_timezone: null,
            objective_type: null,
            is_edit_adgroup_drawer_displayed: false
        }
    },

    computed: {
        visible_in_line: {
            get() {
                return this.visible
            },
            set(value) {
                this.$emit('update:visible', value)
            }
        },

        title_copy_campaign() {
            if (!this.copy_item) {
                return ''
            }

            return `${this.$t('common.copy')} ${this.$t(
                'common.campaign'
            ).toLowerCase()} #${this.copy_item.campaign_id}`
        },

        min_budget_adgroup() {
            if (this.m__selected_ads_account) {
                return this.m__selected_ads_account.min_budget_adgroup
            }

            return 0
        },

        min_budget_campaign() {
            if (this.m__selected_ads_account) {
                return this.m__selected_ads_account.min_budget_campaign
            }

            return 0
        }
    },

    watch: {
        visible_in_line() {
            if (!this.visible_in_line) {
                this.m__data_for_pagination = []
                this.multiple_selection_adgroups = []

                return
            }

            const now = moment()

            const date = now.format('YYYYMMDDHHmmss')

            this.m__type = 'adgroup_id'

            this.copy_item = {
                ...this.item,
                campaign_name: `${this.item.campaign_name}_${date}_copy`
            }

            const filter = {
                filter_value: JSON.stringify([this.copy_item.campaign_id]),
                field_name: 'campaign_ids',
                filter_type: 'IN'
            }
            this.m__filtering = [filter]
            this.m__getReportCampaignsByAccount()
        },

        m__selected_tiktok_account() {
            this.m__fetchAdsAccountsByTiktokAccount()
        },

        m__selected_ads_account() {
            this.selected_advertiser_id =
                this.m__selected_ads_account.advertiser_id
        }
    },

    mounted() {
        this.m__fetchAdsAccountsByTiktokAccount()
    },

    methods: {
        handleSelectionChange(val) {
            this.multiple_selection_adgroups = val
        },

        handleEditAdGroup(adgroup) {
            // console.log(adgroup.adgroup.schedule_start_time)
            // console.log(this.active_adgroup_item.schedule_start_time)

            this.is_edit_adgroup_drawer_displayed = true
            this.active_currency = adgroup.currency
            this.active_timezone = adgroup.timezone
            this.objective_type = this.copy_item.objective_type

            this.active_adgroup_item = {
                ...adgroup.adgroup,
                schedule_start_time: this.p__formatDate(
                    adgroup.adgroup.schedule_start_time
                ),
                schedule_end_time: this.p__formatDate(
                    adgroup.adgroup.schedule_end_time
                ),
                extension: this.p__default_state_infor_adgroup.extension
            }

            this.changeInforAdgroupByObjectiveType(this.objective_type)
        },

        changeInforAdgroupByObjectiveType(objective_type) {
            if (objective_type === 'REACH') {
                this.active_adgroup_item.optimization_goal = 'REACH'
                this.active_adgroup_item.billing_event = 'CPM'

                return
            }

            if (objective_type === 'TRAFFIC') {
                this.active_adgroup_item.optimization_goal = 'CLICK'
                this.active_adgroup_item.billing_event = 'CPC'
                this.active_adgroup_item.promotion_type = 'WEBSITE'
                return
            }

            if (objective_type === 'VIDEO_VIEWS') {
                this.active_adgroup_item.optimization_goal = 'ENGAGED_VIEW'
                this.active_adgroup_item.billing_event = 'CPV'
                this.active_adgroup_item.bid_display_mode = 'CPV'

                return
            }

            if (objective_type === 'LEAD_GENERATION') {
                this.active_adgroup_item.optimization_goal = 'LEAD_GENERATION'
                this.active_adgroup_item.billing_event = 'OCPM'
                this.active_adgroup_item.promotion_type = 'LEAD_GENERATION'
                this.active_adgroup_item.conversion_bid_price = 1

                return
            }

            if (objective_type === 'ENGAGEMENT') {
                this.active_adgroup_item.optimization_goal = 'FOLLOWERS'
                this.active_adgroup_item.billing_event = 'OCPM'
                this.active_adgroup_item.conversion_bid_price = 1

                return
            }

            if (objective_type === 'APP_PROMOTION') {
                this.active_adgroup_item.optimization_goal = 'CLICK'
                this.active_adgroup_item.billing_event = 'CPC'
                this.active_adgroup_item.operating_systems = ['ANDROID']
                this.active_adgroup_item.promotion_type = 'APP_ANDROID'

                return
            }

            if (objective_type === 'WEB_CONVERSIONS') {
                this.active_adgroup_item.optimization_goal = 'CONVERT'
                this.active_adgroup_item.billing_event = 'OCPM'
                this.active_adgroup_item.promotion_type = 'WEBSITE'
                this.active_adgroup_item.conversion_bid_price = 1

                return
            }

            if (objective_type === 'CATALOG_SALES') {
                this.active_adgroup_item.billing_event = 'CPM'
                this.active_adgroup_item.shopping_ads_retargeting_type = 'OFF'

                return
            }

            if (objective_type === 'PRODUCT_SALES') {
                this.active_adgroup_item.shopping_ads_type = 'LIVE'
                this.active_adgroup_item.optimization_goal = 'CLICK'
                this.active_adgroup_item.optimization_event = ''
                this.active_adgroup_item.billing_event = 'CPC'
                this.active_adgroup_item.promotion_type = 'LIVE_SHOPPING'
                this.active_adgroup_item.store_authorized_bc_id = this.bc_id

                return
            }

            this.active_adgroup_item.optimization_goal = 'CLICK'
            this.active_adgroup_item.optimization_event = ''
        },

        handleChangeAdgroup(adgroup) {
            this.m__data_for_pagination = this.m__data_for_pagination.map(
                (item) => {
                    if (item.adgroup.adgroup_id === adgroup.adgroup_id) {
                        return {
                            ...item,
                            adgroup
                        }
                    }

                    return item
                }
            )
        },

        async handleCopy() {
            if (!this.copy_item) {
                return
            }

            if (!this.multiple_selection_adgroups.length) {
                return
            }

            if (!this.copy_item.campaign_name) {
                this.p__showNotify(
                    'warning',
                    this.$t('page.campaign.please_select_input_campaign_name')
                )

                document
                    .getElementById('input_campaign_name_wrapper')
                    .scrollIntoView({ behavior: 'smooth' })
                document.getElementById('input_campaign_name').focus()
                document.getElementById('input_campaign_name').className +=
                    ' border-red border-[1px] rounded-[8px]'

                return false
            }

            this.loading = true
            let has_error = false
            let created_campaign_id = ''

            try {
                const budget =
                    this.item.budget < this.min_budget_campaign
                        ? this.min_budget_campaign
                        : this.item.budget

                const temp = {
                    ...this.copy_item,
                    belong_to_atosa: this.belong_to_atosa,
                    budget
                }

                delete temp.app_promotion_type

                const response_create_campaign = await createCampaign(
                    this.tiktok_account_id,
                    temp
                )

                if (response_create_campaign.code !== 0) {
                    this.loading = false
                    this.p__showNotify(
                        'error',
                        this.$t('message.xxx_fail', {
                            xxx: `${this.$t(`common.copy`)} ${this.$t(
                                `common.campaign`
                            )}`
                        })
                    )
                    return
                }

                created_campaign_id = response_create_campaign.data.campaign_id

                const list_adgroups = this.multiple_selection_adgroups.map(
                    (item) => {
                        const temp = { ...item.adgroup }
                        removeEmptyParams(temp)
                        return temp
                    }
                )

                for (const adgroup of list_adgroups) {
                    const temp_adgroup = JSON.parse(JSON.stringify(adgroup))

                    const response_get_ads = await getAds(
                        this.m__selected_tiktok_account.id,
                        {
                            advertiser_id: this.selected_advertiser_id,
                            filtering: JSON.stringify({
                                adgroup_ids: [temp_adgroup.adgroup_id]
                            })
                        }
                    )

                    if (response_get_ads.code !== 0) {
                        continue
                    }

                    const list_ads = response_get_ads.data.list.map((item) => {
                        if (!item.ad_text) {
                            item.ad_text = 'ad'
                        }
                        delete item.brand_safety_postbid_partner
                        removeEmptyParams(item)
                        return item
                    })
                    if (!list_ads.length) {
                        continue
                    }

                    this.m__changeScheduleTime(
                        temp_adgroup,
                        this.objective_type
                    )

                    this.m__changeScheduleTime2(temp_adgroup)

                    const response_create_ad_group = await createAdGroup(
                        this.m__selected_tiktok_account.id,
                        {
                            ...temp_adgroup,
                            campaign_id: created_campaign_id,
                            belong_to_atosa: this.belong_to_atosa
                        }
                    )

                    if (response_create_ad_group.data?.adgroup_id) {
                        await createAd(this.m__selected_tiktok_account.id, {
                            belong_to_atosa: this.belong_to_atosa,
                            adgroup_id:
                                response_create_ad_group.data.adgroup_id,
                            advertiser_id: this.selected_advertiser_id,
                            creatives: list_ads
                        })
                    }
                }
                this.p__event_bus.$emit('eb_reload_campaign')
                this.p__event_bus.$emit('eb_reload_adgroup')
                this.p__event_bus.$emit('eb_reload_ad')

                this.visible_in_line = false

                this.p__showNotify(
                    'success',
                    this.$t('message.xxx_success', {
                        xxx: `${this.$t(`common.copy`)} ${this.$t(
                            `common.campaign`
                        )}`
                    })
                )
            } catch (error) {
                has_error = true

                console.error(error)
                this.p__showNotify(
                    'error',
                    this.$t('message.xxx_fail', {
                        xxx: `${this.$t(`common.copy`)} ${this.$t(
                            `common.campaign`
                        )}`
                    })
                )
            }

            if (has_error && created_campaign_id) {
                try {
                    await updateCampaignStatus(this.tiktok_account_id, {
                        advertiser_id: this.advertiser_id,
                        campaign_ids: [created_campaign_id],
                        operation_status: 'DELETE',
                        belong_to_atosa: this.belong_to_atosa
                    })
                } catch (error) {
                    console.error(error)
                }
            }

            this.loading = false
        }
    }
}
</script>
